import React, { useState } from "react";
import { rem } from "polished";
import styled from "styled-components";
import { motion } from "framer-motion";

import mq from "../../../helpers/media-queries";

import { ReactComponent as CheckIcon } from "../../../assets/img/check-icon.svg";
import { ReactComponent as ArrowDown } from "../../../assets/img/arrow-down.svg";

const El = styled.ul`
	padding-top: ${rem(10)};
	border-top: 1px solid #dbdbdb;
	font-family: sans-serif;

	h2 {
		font-size: ${rem(24)};
		color: #000;
		line-height: 1.2;
	}

	${mq("sm", "min")} {
	}
`;

const Text = styled.div`
	font-size: ${rem(13)};
	line-height: 1.5;
	color: #5c5e62;
	margin-bottom: ${rem(15)};

	& > * + * {
		margin-top: ${rem(10)};
	}
`;

const ExploreContainer = styled.div`
	padding: ${rem(10)} ${rem(24)} 0 ${rem(24)};
`;

const ExploreButton = styled.button`
	font-size: ${rem(17)};
	width: 100%;
	font-family: Sans-serif;
	color: #414347;
	padding: ${rem(10)};
	border-radius: 999em;
	font-weight: 500;
	appearance: none;
	border: 0;
	background: #f4f4f4;
	position: relative;

	&:not(:disabled) {
		cursor: pointer;
	}
`;

const FeaturesList = styled.ul`
	margin-top: ${rem(10)};
	color: #433129;

	li {
		font-size: ${rem(15)};
		padding-left: ${rem(25)};
		position: relative;
		line-height: ${22 / 15};

		span {
			font-size: ${rem(12)};
			opacity: 0.5;
		}

		svg {
			position: absolute;
			left: ${rem(2)};
			top: ${rem(3.5)};
			fill: #cc6f4c;
			width: ${rem(15)};
			height: ${rem(15)};
		}
	}
`;

const FeaturesListItem = styled(motion.li)`
	font-size: ${rem(15)};
	padding-left: ${rem(25)};
	position: relative;
	line-height: ${22 / 15};

	span {
		font-size: ${rem(12)};
		opacity: 0.5;
	}

	svg {
		position: absolute;
		left: ${rem(2)};
		top: ${rem(3.5)};
		fill: #cc6f4c;
		width: ${rem(15)};
		height: ${rem(15)};
	}
`;

const RemainingItemsContainer = styled(motion.div)`
	overflow: hidden;
`;

const SeeAllButton = styled(motion.button)`
	appearance: none;
	border: 0;
	background: none;
	color: #2d71b6;
	font-family: sans-serif;
	font-size: ${rem(15)};
	margin-top: ${rem(15)};
	margin-left: ${rem(25)};
	padding: 0;
	padding-right: ${rem(26)};
	cursor: pointer;
	position: relative;

	svg {
		width: ${rem(16)};
		height: ${rem(18)};
		position: absolute;
		right: 0;
		top: 50%;
		margin-top: ${rem(-9)};

		path {
			fill: currentColor;
		}
	}
`;

const ListTitle = styled.p`
	font-size: ${rem(13)};
	font-family: helvetica;
	color: #433129;
`;

const SeeAllButtonContainer = styled(motion.div)`
	overflow: hidden;
	padding-bottom: ${rem(20)};
`;

const FeaturesListComponent = ({ features }) => {
	const [isOpen, setOpen] = useState(false);

	let toShow = 5,
		showing = [],
		remaining = [];

	if (features.length > toShow) {
		for (let i = 0; i < features.length; i++) {
			i < toShow ? showing.push(features[i]) : remaining.push(features[i]);
		}
	} else {
		showing = features;
	}

	return (
		<React.Fragment>
			<FeaturesList>
				{showing.map((item, index) => (
					<FeaturesListItem key={index}>
						<CheckIcon />
						{item.title}
						<span> {item.value}</span>
					</FeaturesListItem>
				))}

				{remaining.length > 0 && (
					<RemainingItemsContainer
						animate={isOpen ? { height: "auto" } : { height: 0 }}
						transition={{ ease: "easeOut", duration: 0.3 }}
					>
						{remaining.map((item, index) => (
							<FeaturesListItem
								key={index}
								animate={isOpen ? { opacity: 1, x: 0 } : { opacity: 0, x: 10 }}
								transition={{
									ease: "easeOut",
									duration: 0.3,
									delay: isOpen ? 0.2 + 0.1 * index : 0,
								}}
							>
								<CheckIcon />
								{item.title}
								<span> {item.value}</span>
							</FeaturesListItem>
						))}
					</RemainingItemsContainer>
				)}
			</FeaturesList>

			{remaining.length > 0 && (
				<SeeAllButtonContainer
					animate={
						isOpen ? { height: 0, opacity: 0 } : { height: "auto", opacity: 1 }
					}
					transition={{ ease: "easeOut", duration: 0.3, delay: 0 }}
				>
					<SeeAllButton
						animate={isOpen && { y: 10, opacity: 0 }}
						transition={{ ease: "easeOut", duration: 0.3 }}
						onClick={() => {
							setOpen(true);
						}}
					>
						Reveal All <ArrowDown />
					</SeeAllButton>
				</SeeAllButtonContainer>
			)}
		</React.Fragment>
	);
};

const KeyFeatures = ({ data, popupOpen, setPopupOpen }) => {
	const modalToggle = (isOpen) => {};

	return (
		<React.Fragment>
			<El>
				<Text dangerouslySetInnerHTML={{ __html: data.text }} />
				<FeaturesListComponent features={data.features} />

				<ExploreContainer>
					<ExploreButton onClick={() => setPopupOpen(!popupOpen)}>
						Explore Key Features
					</ExploreButton>
				</ExploreContainer>
			</El>
		</React.Fragment>
	);
};

export default KeyFeatures;
